import React from 'react';
import { isMobile } from 'react-device-detect';
import { CheckPicker, Input, Button, FlexboxGrid } from 'rsuite';
import { COLOR_OPTIONS, RARITY_OPTIONS, CONDITION_OPTIONS } from '../../helpers/filterConstants';
import useDebouncedSearch from '../../helpers/useDebouncedSearch';

const FILTER_SPACING = {
  searchWidth: isMobile ? '100%' : 200,
  pickerWidth: isMobile ? '100%' : 160,
  conditionPickerWidth: isMobile ? '100%' : 170,
};

const CollectionFilters = ({
  nameSearch,
  setNameSearch,
  colorFilter,
  setColorFilter,
  rarityFilter,
  setRarityFilter,
  conditionFilter,
  setConditionFilter,
  onClearFilters,
  totalCount,
  filteredCount,
  notOwnedFilter,
  setNotOwnedFilter,
}) => {
  const [searchInput, setSearchInput] = useDebouncedSearch(nameSearch, setNameSearch);

  const hasActiveFilters =
    nameSearch ||
    colorFilter.length > 0 ||
    rarityFilter.length > 0 ||
    conditionFilter.length > 0 ||
    notOwnedFilter;

  const mobileItemStyle = isMobile ? { width: '100%' } : undefined;

  return (
    <FlexboxGrid
      style={{
        padding: '10px 0',
        gap: 12,
        flexWrap: 'wrap',
        alignItems: 'center',
        marginBottom: 12,
        flexDirection: isMobile ? 'column' : 'row',
      }}
    >
      <FlexboxGrid.Item style={mobileItemStyle}>
        <Input
          placeholder="Search by name..."
          value={searchInput}
          onChange={setSearchInput}
          style={{ width: FILTER_SPACING.searchWidth }}
        />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item style={mobileItemStyle}>
        <CheckPicker
          data={COLOR_OPTIONS}
          value={colorFilter}
          onChange={setColorFilter}
          placeholder="Colors"
          style={{ width: FILTER_SPACING.pickerWidth }}
          searchable={false}
          block={isMobile}
        />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item style={mobileItemStyle}>
        <CheckPicker
          data={RARITY_OPTIONS}
          value={rarityFilter}
          onChange={setRarityFilter}
          placeholder="Rarity"
          style={{ width: FILTER_SPACING.pickerWidth }}
          searchable={false}
          block={isMobile}
        />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item style={mobileItemStyle}>
        <CheckPicker
          data={CONDITION_OPTIONS}
          value={conditionFilter}
          onChange={setConditionFilter}
          placeholder="Condition"
          style={{ width: FILTER_SPACING.conditionPickerWidth }}
          searchable={false}
          block={isMobile}
        />
      </FlexboxGrid.Item>
      {notOwnedFilter !== undefined && (
        <FlexboxGrid.Item style={mobileItemStyle}>
          <Button
            appearance={notOwnedFilter ? 'primary' : 'ghost'}
            size="sm"
            onClick={() => setNotOwnedFilter(!notOwnedFilter)}
          >
            Needs Acquiring
          </Button>
        </FlexboxGrid.Item>
      )}
      {hasActiveFilters && (
        <FlexboxGrid.Item>
          <Button appearance="ghost" onClick={onClearFilters} size="sm">
            Clear Filters
          </Button>
        </FlexboxGrid.Item>
      )}
      {hasActiveFilters && (
        <FlexboxGrid.Item>
          <span style={{ color: '#aaa', fontSize: 13 }}>
            Showing {filteredCount} of {totalCount}
          </span>
        </FlexboxGrid.Item>
      )}
    </FlexboxGrid>
  );
};

export default CollectionFilters;
